module.exports = __webpack_public_path__ + "img/67.8160f68c.jpg";